import { getFirstItem, getSecondItem } from '@visx/shape';
import { extent } from '@visx/vendor/d3-array';
const getStack = bar => bar?.data?.stack;

// returns average of top + bottom of bar (the middle) as this enables more accurately
// finding the nearest datum to a FocusEvent (which is based on the middle of the rect bounding box)
const getNumericValue = bar => (getFirstItem(bar) + getSecondItem(bar)) / 2;

/** Constructs the `DataRegistryEntry`s for a BarStack, using the stacked data. */
export default function getBarStackRegistryData(stackedData, comprehensiveDomain, horizontal) {
  const [xAccessor, yAccessor] = horizontal ? [getNumericValue, getStack] : [getStack, getNumericValue];
  return stackedData.map((data, index) => {
    const entry = {
      key: data.key,
      data,
      xAccessor,
      yAccessor
    };

    // update the numeric domain to account for full data stack
    // only need to do this for one key
    if (comprehensiveDomain.length > 0 && index === 0) {
      if (horizontal) {
        entry.xScale = scale => scale.domain(extent(scale.domain().concat(comprehensiveDomain)));
      } else {
        entry.yScale = scale => scale.domain(extent(scale.domain().concat(comprehensiveDomain)));
      }
    }
    return entry;
  }).filter(entry => entry);
}